/* eslint-disable no-param-reassign */

import axios from 'axios';
import { message } from 'antd';

import baseURL, { testAuthToken } from '../../settings';

const isProd = process.env.NODE_ENV === 'production';

const instance = axios.create({
  baseURL,
  timeout: 5000,
});

instance.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    const { data } = error.response;
    let text = data && data.error.message;

    if (data && data.error.violations) {
      text += ` ${JSON.stringify(data.error.violations)}`;
    }

    message.error(text || 'Something went wrong');
    return Promise.reject(error.response);
  },
);

instance.interceptors.request.use(config => {
  if (isProd) {
    const token = sessionStorage.getItem('authToken');
    if (!token) {
      window.location.href = '/login';
      return false;
    }
    config.headers.Authorization = token;
  } else {
    config.headers.Authorization = testAuthToken;
  }
  return config;
});

export default instance;
